import * as React from 'react'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import { lightPalette } from '../styles/themes/colors'

interface ElevationOnScrollProps {
	disableHysteresis?: boolean
	elevation?: number
	threshold?: number
	window?: () => Window
	children?: React.ReactElement<{ elevation?: number; style?: object }>
	isNewLayout?: boolean
}

export default function ElevationOnScroll({
	disableHysteresis = true,
	threshold = 0,
	elevation = 2,
	window,
	children,
	isNewLayout = false,
}: ElevationOnScrollProps) {
	const trigger = useScrollTrigger({
		disableHysteresis,
		threshold,
		target: window ? window() : undefined,
	})
	return children
		? React.cloneElement(children, {
				elevation: trigger ? elevation : 0,
				style: {
					...(isNewLayout && {
						boxShadow: trigger
							? `0px 2px 4px -1px ${lightPalette.background.scrim}`
							: `unset`,
					}),
				},
			})
		: null
}
